/* tslint:disable */
/* eslint-disable */
/**
 * K2B
 * The K2B API description
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { getFromStorage } from '../../app/helpers';
/**
 * AnalyticsKpiApi - axios parameter creator
 * @export
 */
export const AnalyticsKpiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationId 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsKpiControllerFindByOrganizationIdYearQuarter: async (organizationId: string, year: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling analyticsKpiControllerFindByOrganizationIdYearQuarter.');
            }
            // verify required parameter 'year' is not null or undefined
            if (year === null || year === undefined) {
                throw new RequiredError('year','Required parameter year was null or undefined when calling analyticsKpiControllerFindByOrganizationIdYearQuarter.');
            }
            const localVarPath = `/analytics-kpi/organization/{organizationId}/year/{year}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            localVarHeaderParameter["Authorization"] = "Bearer " + getFromStorage("token");
            localVarHeaderParameter['Content-Type'] = 'application/json';
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsKpiApi - functional programming interface
 * @export
 */
export const AnalyticsKpiApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} organizationId 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsKpiControllerFindByOrganizationIdYearQuarter(organizationId: string, year: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<any>>>> {
            const localVarAxiosArgs = await AnalyticsKpiApiAxiosParamCreator(configuration).analyticsKpiControllerFindByOrganizationIdYearQuarter(organizationId, year, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AnalyticsKpiApi - factory interface
 * @export
 */
export const AnalyticsKpiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} organizationId 
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsKpiControllerFindByOrganizationIdYearQuarter(organizationId: string, year: number, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<any>>> {
            return AnalyticsKpiApiFp(configuration).analyticsKpiControllerFindByOrganizationIdYearQuarter(organizationId, year, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsKpiApi - object-oriented interface
 * @export
 * @class AnalyticsKpiApi
 * @extends {BaseAPI}
 */
export class AnalyticsKpiApi extends BaseAPI {
    /**
     * 
     * @param {string} organizationId 
     * @param {number} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsKpiApi
     */
    public async analyticsKpiControllerFindByOrganizationIdYearQuarter(organizationId: string, year: number, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<any>>> {
        return AnalyticsKpiApiFp(this.configuration).analyticsKpiControllerFindByOrganizationIdYearQuarter(organizationId, year, options).then((request) => request(this.axios, this.basePath));
    }
}
